/*
 * PlanWithUs.jsx
 * Created by Destin Frasier on 05/02/18
 */

import React from 'react';
import { LaunchDarklyProvider, FeatureFlag } from '../../sharedComponents/LaunchDarkly';

export default class PlanWithUs extends React.Component {
    render() {
        return (
            <ul className="nav-footer-list">
                <li>
                    <a href="/articles">Find Trip Inspiration</a>
                </li>
                <li>
                    <a href="/trips/new">Build a Trip</a>
                </li>
                <li>
                    <a href="/pass/">Buy a Pass</a>
                </li>
                <li>
                    <a href="/lottery/available">Enter a Lottery</a>
                </li>
                <li>
                    <a href="/mobile-app">Checkout our Mobile App</a>
                </li>

                <LaunchDarklyProvider>
                    <FeatureFlag flag="gearRentalFooterLink">
                        <li>
                            <a href="/rentals">Gear & RV Rentals</a>
                        </li>
                    </FeatureFlag>
                </LaunchDarklyProvider>
            </ul>
        );
    }
}
